import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const PaymentFailed = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <div className="flex justify-center mb-4">
          <XCircle className="w-16 h-16 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Payment Failed
        </h1>
        
        <p className="text-gray-600 mb-6">
          We couldn't process your payment. Please try again or contact support if the problem persists.
        </p>

        <div className="flex gap-4 justify-center">
          <Link
            to="/"
            className="btn btn-secondary"
          >
            Return to Home
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="btn"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};